import { Value } from '@philips-emr/tws-core';
import { Validation } from '@philips-emr/tws-core/lib/services/model-service';

function validate(value: Value): Validation[] {
  const valid = Boolean(value);

  return [{
    message: valid ? '' : 'tws.validator.required',
    name: 'boolean-validator',
    valid,
  }];
}

export { validate as BooleanValidator };
